<template>
  <component
    :is="computedTag"
    v-if="parsedContent"
    class="pre-line"
    v-html="parsedContent"
  />
</template>



<script>
  export default {
    name: 'FormattedContent',

    props: {
      content: {
        type: String,
        default: ''
      },

      tag: {
        type: String,
        default: 'p'
      }
    },

    data() {
      return {
        tagOverride: null
      };
    },

    computed: {
      computedTag() {
        return this.tagOverride || this.tag;
      },

      parsedContent() {
        return this.parseContentString(this.content);
      }
    },

    methods: {
      parseContentString(content) {
        if (!content) {
          return null;
        }

        const urlRegex = /([^\s]+\.(com|co|net|org)([^\s]*(?=\w))?[\w]?)/g;
        content = content.replace(urlRegex, (match, cg1) => {
          if (cg1.indexOf('@') > -1) {
            return `<a href="mailto:${cg1}" class="link primary">${cg1}</a>`;
          }

          const url = cg1.indexOf('://') === -1 ? `https://${cg1}` : cg1;
          return `<a href="${url}" target="_blank" class="link primary">${cg1}</a>`;
        });

        const phoneRegex = /((\+?[0-9]+\s)?\(?[0-9]{3}\)?[\s\-.][0-9]{3}[\s\-.][0-9]{4})/g;
        content = content.replace(phoneRegex, (match) => {
          const phone = match.replace(/[^0-9]/g, '');
          return `<a href="tel:${phone}" class="link primary">${match}</a>`;
        });


        /* string starts with a number followed by a dot or close parenthesis and a space. */
        const startsAsOrderedList = /^(\d+\.|\d+\)+\s)/;
        /* string includes a line return followed by a number and a dot or a number and a close parenthesis and a space. */
        const hasAdditionalOrderedListLines = /(\r|\n)+(\d+\.|\d+\)+\s)/g;
        if (startsAsOrderedList.test(content) && hasAdditionalOrderedListLines.test(content)) {
          this.tagOverride = 'div';

          const lineItems = content.split('\n');
          content = '<ol class="ordered-list">';
          content += lineItems.map(line => `<li>${line.replace(/(\d+\.|\d+\))+\s/, '')}</li>`).join('');
          content += '</ol>';
        }

        return content;
      }
    }
  };
</script>
